// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as BasicTypes$Showside from "../types/BasicTypes.bs.js";
import * as LCPContext$Showside from "../context/LCPContext.bs.js";
import * as UseSidebar$Showside from "../hook/UseSidebar.bs.js";
import * as Prioritize2$Showside from "../utils/Prioritize2.bs.js";
import * as ProductCard$Showside from "./ProductCard.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as CategoryCard$Showside from "./CategoryCard.bs.js";
import * as ListPageGrid$Showside from "./ListPageGrid.bs.js";
import * as Sidebar_Lazy$Showside from "./Sidebar_Lazy.bs.js";
import * as ErrorReporter$Showside from "./ErrorReporter.bs.js";
import * as ListPagePills$Showside from "./ListPagePills.bs.js";
import * as ListPageTypes$Showside from "../types/ListPageTypes.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as SectionContent$Showside from "./SectionContent.bs.js";
import * as ListPageHeading$Showside from "./ListPageHeading.bs.js";
import * as ListPageToolbar$Showside from "./ListPageToolbar.bs.js";
import * as RollbarInstance$Showside from "../utils/RollbarInstance.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as FiltersPanel_Lazy$Showside from "./FiltersPanel_Lazy.bs.js";
import * as UseDisplayVariantBy$Showside from "../hook/UseDisplayVariantBy.bs.js";
import * as ListPageMobileNavbar$Showside from "./ListPageMobileNavbar.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ListPageMobileFilters$Showside from "./ListPageMobileFilters.bs.js";
import * as ListPageSidebarWrapper$Showside from "./ListPageSidebarWrapper.bs.js";
import * as RelatedProductsContent$Showside from "./RelatedProductsContent.bs.js";
import * as GridDensityZoomProvider$Showside from "../context/GridDensityZoomProvider.bs.js";
import * as ProductDetailsPage_Lazy$Showside from "../pages/ProductDetailsPage_Lazy.bs.js";
import * as ListPageLayoutController$Showside from "../hook/ListPageLayoutController.bs.js";
import * as UserSavedProductsContent$Showside from "./UserSavedProductsContent.bs.js";
import * as UserSavedProductsProvider$Showside from "../context/UserSavedProductsProvider.bs.js";
import * as UseCategoryDisplayPriority$Showside from "../hook/UseCategoryDisplayPriority.bs.js";
import * as StoreCategoryProductsContent$Showside from "./StoreCategoryProductsContent.bs.js";
import * as LegacyShowside_CategoryDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_CategoryDecoders.bs.js";
function getPreferredContentType(category) {
  var match = Category$Showside.ExternalConnection.getConnection(category);
  if (match === undefined) {
    return /* Products */0;
  }
  if (typeof match !== "number") {
    return /* Products */0;
  }
  switch (match) {
    case /* History */0:
      return /* History */3;
    case /* Favorites */1:
      return /* Favorites */2;
    case /* StoreCart */2:
      return /* StoreCart */4;
  }
}
function ListPageContent$OptimizedForLCP(Props) {
  var category = Props.category;
  var parentCategory = Props.parentCategory;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var index = Props.index;
  var preferredContentType = Props.preferredContentType;
  var priority = Props.priority;
  var anchorHookResult = Props.anchorHookResult;
  var layout = React.useMemo(function () {
    var match = category.userSelectedLayout;
    if (typeof match === "number") {
      return;
    }
    switch (match.TAG | 0) {
      case /* SubCategoriesGrid */2:
      case /* ProductGrid */3:
        return {
          TAG: /* GridLayout */1,
          _0: match._0
        };
      default:
        return {
          TAG: /* SliderLayout */0,
          _0: match._0
        };
    }
  }, [category.userSelectedLayout]);
  var match = category.userSelectedLayout;
  var preferredContentType$1;
  if (typeof match === "number") {
    preferredContentType$1 = /* Category */1;
  } else {
    switch (match.TAG | 0) {
      case /* ProductGrid */3:
      case /* ProductSlider */4:
        preferredContentType$1 = preferredContentType;
        break;
      default:
        preferredContentType$1 = /* Category */1;
    }
  }
  var match$1 = category.userSelectedLayout;
  var shouldShowHeader;
  if (typeof match$1 === "number") {
    shouldShowHeader = undefined;
  } else {
    switch (match$1.TAG | 0) {
      case /* ProductGrid */3:
      case /* ProductSlider */4:
        shouldShowHeader = true;
        break;
      default:
        shouldShowHeader = undefined;
    }
  }
  if (layout === undefined) {
    return null;
  }
  var tmp = {
    index: index,
    preferredContentType: preferredContentType$1,
    category: category,
    parentCategory: parentCategory,
    layout: layout,
    scrollableContainerRef: scrollableContainerRef,
    priority: priority
  };
  if (shouldShowHeader !== undefined) {
    tmp.shouldShowHeader = Caml_option.valFromOption(shouldShowHeader);
  }
  if (anchorHookResult !== undefined) {
    tmp.anchorHookResult = Caml_option.valFromOption(anchorHookResult);
  }
  return React.createElement(SectionContent$Showside.make, tmp);
}
ListPageContent$OptimizedForLCP.displayName = "ListPageContent.OptimizedForLCP";
var OptimizedForLCP = {
  make: ListPageContent$OptimizedForLCP
};
function ListPageContent$LazySection(Props) {
  var category = Props.category;
  var parentCategory = Props.parentCategory;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var index = Props.index;
  var anchorHookResult = Props.anchorHookResult;
  var match = RouterProvider$Showside.useRouter(undefined);
  var previewMode = match.previewMode;
  var match$1 = LCPContext$Showside.use(undefined);
  var isMainImageRendered = match$1.isMainImageRendered;
  return React.createElement(Prioritize2$Showside.make, {
    render: function (priority) {
      var tmp;
      if (isMainImageRendered && priority <= 1 || priority === 0 || Caml_obj.equal(previewMode, /* PreviewHead */0)) {
        tmp = React.createElement(ListPageContent$OptimizedForLCP, {
          category: category,
          parentCategory: parentCategory,
          scrollableContainerRef: scrollableContainerRef,
          index: index,
          preferredContentType: getPreferredContentType(category),
          priority: priority,
          anchorHookResult: anchorHookResult
        });
      } else {
        var tmp$1 = {
          category: category
        };
        if (anchorHookResult !== undefined) {
          tmp$1.anchorHookResult = Caml_option.valFromOption(anchorHookResult);
        }
        tmp = React.createElement(SectionContent$Showside.SectionPlaceholder.make, tmp$1);
      }
      return React.createElement(React.Fragment, undefined, tmp);
    },
    key: category.id
  });
}
ListPageContent$LazySection.displayName = "ListPageContent.LazySection";
var LazySection = {
  make: ListPageContent$LazySection
};
function ListPageContent$Show(Props) {
  var listPageContentType = Props.listPageContentType;
  var parentCategory = Props.parentCategory;
  var topLevelCategories = Props.topLevelCategories;
  var isForcingPLP = Props.isForcingPLP;
  var isMobile = Props.isMobile;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var anchorHookResult = Props.anchorHookResult;
  var onBackClick = Props.onBackClick;
  var onAddToCart = Props.onAddToCart;
  var onCategoryClick = Props.onCategoryClick;
  var onOpenLink = Props.onOpenLink;
  var displayVariantBy = UseDisplayVariantBy$Showside.useDisplayVariantBy(undefined);
  var match = ConfigurationProvider$Showside.use(undefined);
  var settings = match.config.settings;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var match$2 = LCPContext$Showside.use(undefined);
  var onMainImageRendered = match$2.onMainImageRendered;
  var match$3 = EntrypointContext$Showside.use(undefined);
  var isMiniPDPVisible = match$3.isMiniPDPVisible;
  var onProductClick = match$3.onProductClick;
  var trackEvent = match$3.trackEvent;
  var match$4 = GridDensityZoomProvider$Showside.use(undefined);
  var isZoomEnabled = match$4.isZoomEnabled;
  var gridColumns = match$4.gridColumns;
  var match$5 = UserSavedProductsProvider$Showside.use(undefined);
  var history = match$5.history;
  var onRelatedProductClicked = React.useCallback(function (product) {
    return function (variant) {
      Curry.app(trackEvent, ["Clicked Related Product Card", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      return Curry._2(onProductClick, product, variant);
    };
  }, [trackEvent, onProductClick]);
  var renderHistorySlider = function (param) {
    var canRenderHistorySlider = settings.historyEnabled && settings.plpHistorySliderEnabled && history.value.length !== 0;
    if (canRenderHistorySlider) {
      return React.createElement("div", {
        style: {
          paddingTop: CSS$Showside.intToPx(isMobile ? 20 : 24),
          paddingBottom: CSS$Showside.intToPx(isMobile ? 20 : 24)
        }
      }, React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["text-primary font-heading", "mb-6", isMobile ? "text-lg" : "text-xl"])),
        style: {
          paddingRight: CSS$Showside.intToPx(isMobile ? 12 : 24),
          paddingLeft: CSS$Showside.intToPx(isMobile ? 12 : 24)
        }
      }, "Recently Viewed"), React.createElement(UserSavedProductsContent$Showside.make, {
        layout: {
          TAG: /* SliderLayout */0,
          _0: {
            slidesPerView: isMobile ? 2.1 : 4.1,
            gap: isMobile ? (/* Pixels */{
              _0: 6
            }) : (/* Pixels */{
              _0: 8
            }),
            maxWidth: BasicTypes$Showside.emptySliderPayload.maxWidth,
            padding: BasicTypes$Showside.emptySliderPayload.padding,
            rows: BasicTypes$Showside.emptySliderPayload.rows,
            effect: BasicTypes$Showside.emptySliderPayload.effect,
            nav: BasicTypes$Showside.emptySliderPayload.nav,
            transition: BasicTypes$Showside.emptySliderPayload.transition,
            transitionSpeed: BasicTypes$Showside.emptySliderPayload.transitionSpeed,
            autoplay: BasicTypes$Showside.emptySliderPayload.autoplay,
            autoplayDelay: BasicTypes$Showside.emptySliderPayload.autoplayDelay,
            loop: BasicTypes$Showside.emptySliderPayload.loop
          }
        },
        zoomable: false,
        requestType: "history"
      }));
    } else {
      return null;
    }
  };
  var getContentOptimizedForLCP = function (categories) {
    return Belt_Array.mapWithIndex(Belt_Array.keep(categories, function (category) {
      if (Category$Showside.hasAnyItems(category)) {
        return category.visibleInSectionList;
      } else {
        return false;
      }
    }), function (index, category) {
      return React.createElement(ListPageContent$LazySection, {
        category: category,
        parentCategory: parentCategory,
        scrollableContainerRef: scrollableContainerRef,
        index: index,
        anchorHookResult: anchorHookResult,
        key: category.id
      });
    });
  };
  if (typeof listPageContentType === "number") {
    switch (listPageContentType) {
      case /* HistoryProducts */0:
        return React.createElement(UserSavedProductsContent$Showside.make, {
          layout: {
            TAG: /* GridLayout */1,
            _0: {
              columns: isZoomEnabled ? gridColumns : isMobile ? /* TwoColumnGrid */1 : /* FourColumnGrid */3,
              gap: BasicTypes$Showside.emptyGridPayload.gap,
              maxRows: BasicTypes$Showside.emptyGridPayload.maxRows,
              maxWidth: BasicTypes$Showside.emptyGridPayload.maxWidth,
              padding: BasicTypes$Showside.emptyGridPayload.padding,
              pattern: BasicTypes$Showside.emptyGridPayload.pattern
            }
          },
          requestType: "history"
        });
      case /* FavoriteProducts */1:
        return React.createElement(UserSavedProductsContent$Showside.make, {
          layout: {
            TAG: /* GridLayout */1,
            _0: {
              columns: isZoomEnabled ? gridColumns : isMobile ? /* TwoColumnGrid */1 : /* FourColumnGrid */3,
              gap: BasicTypes$Showside.emptyGridPayload.gap,
              maxRows: BasicTypes$Showside.emptyGridPayload.maxRows,
              maxWidth: BasicTypes$Showside.emptyGridPayload.maxWidth,
              padding: BasicTypes$Showside.emptyGridPayload.padding,
              pattern: BasicTypes$Showside.emptyGridPayload.pattern
            }
          },
          requestType: "favorites"
        });
      case /* StoreCartProducts */2:
        return React.createElement(UserSavedProductsContent$Showside.make, {
          layout: {
            TAG: /* GridLayout */1,
            _0: {
              columns: isZoomEnabled ? gridColumns : isMobile ? /* TwoColumnGrid */1 : /* FourColumnGrid */3,
              gap: BasicTypes$Showside.emptyGridPayload.gap,
              maxRows: BasicTypes$Showside.emptyGridPayload.maxRows,
              maxWidth: BasicTypes$Showside.emptyGridPayload.maxWidth,
              padding: BasicTypes$Showside.emptyGridPayload.padding,
              pattern: BasicTypes$Showside.emptyGridPayload.pattern
            }
          },
          requestType: "cart"
        });
      case /* UnknownListing */3:
        return React.createElement(ErrorReporter$Showside.make, {
          error: RollbarInstance$Showside.makeError(false, "Could not find a suitable view for this category \"" + Belt_Option.mapWithDefault(match$1.listPageType, "", function (id) {
            if (typeof id === "number") {
              switch (id) {
                case /* Favorites */0:
                  return "Favorites";
                case /* History */1:
                  return "History";
                case /* StoreCart */2:
                  return "StoreCart";
              }
            } else {
              switch (id.TAG | 0) {
                case /* Category */0:
                  return "Category(" + id._0 + ")";
                case /* Product */1:
                  return "Product(" + id._0 + ")";
                case /* StoreCategory */2:
                  return "StoreCategory(" + id._0.categoryId + ")";
              }
            }
          }) + "\"."),
          redirect: onBackClick
        });
      case /* EmptyListing */4:
        return null;
    }
  } else {
    switch (listPageContentType.TAG | 0) {
      case /* IndexSlider */0:
        return getContentOptimizedForLCP(topLevelCategories);
      case /* IndexGrid */1:
        var gridPayload = listPageContentType._0;
        var content = Belt_Array.map(Belt_Array.keep(topLevelCategories, function (category) {
          if (Category$Showside.isIndexNode(category)) {
            return false;
          } else {
            return category.visibleInParent;
          }
        }), function (category) {
          return React.createElement(CategoryCard$Showside.make, {
            category: category,
            shape: Belt_Option.mapWithDefault(settings.indexNode, settings.categoryCardShape, function (node) {
              return Category$Showside.CategoryCard.getCardShape(undefined, undefined, node.card);
            }),
            onClick: onCategoryClick,
            key: category.id
          });
        });
        return React.createElement(ListPageGrid$Showside.make, {
          columns: gridPayload.columns,
          children: content,
          gap: gridPayload.gap
        });
      case /* IndexWithFilters */2:
        var category = listPageContentType._0;
        var gridPayload$1 = category.forcedPLPLayout;
        var gridLayout;
        gridLayout = typeof gridPayload$1 === "number" || gridPayload$1.TAG !== /* ProductGrid */3 ? {
          columns: /* SevenColumnGrid */6,
          gap: /* Half */1,
          maxRows: undefined,
          maxWidth: undefined,
          padding: undefined,
          pattern: undefined
        } : gridPayload$1._0;
        return React.createElement(React.Fragment, undefined, React.createElement(SectionContent$Showside.make, {
          index: 0,
          preferredContentType: /* Products */0,
          shouldShowHeader: !isForcingPLP && Category$Showside.hasSubCategories(category),
          shouldShowBackToTopButton: !isMobile,
          category: category,
          parentCategory: parentCategory,
          layout: {
            TAG: /* GridLayout */1,
            _0: gridLayout
          },
          scrollableContainerRef: scrollableContainerRef,
          enableInlineMedia: true,
          isThemeEnabled: false
        }), renderHistorySlider(undefined));
      case /* CLPGrid */3:
        return React.createElement(SectionContent$Showside.make, {
          index: 0,
          preferredContentType: /* Category */1,
          shouldShowHeader: false,
          category: listPageContentType._0,
          parentCategory: parentCategory,
          layout: {
            TAG: /* GridLayout */1,
            _0: listPageContentType._1
          },
          scrollableContainerRef: scrollableContainerRef,
          isThemeEnabled: false
        });
      case /* CLPSlider */4:
        return getContentOptimizedForLCP(Category$Showside.getChildren(listPageContentType._0));
      case /* CLPWithHeader */5:
        var category$1 = listPageContentType._0;
        var headerContent;
        if (isMobile || !settings.smartbarEnabled) {
          var newrecord = Caml_obj.obj_dup(category$1);
          headerContent = React.createElement(SectionContent$Showside.make, {
            index: 0,
            preferredContentType: /* Category */1,
            applyVisibleInHeader: true,
            category: (newrecord.title = StringUtils$Showside.concatWithoutRepeat("All", category$1.title), newrecord),
            parentCategory: parentCategory,
            layout: {
              TAG: /* SliderLayout */0,
              _0: listPageContentType._1
            },
            scrollableContainerRef: scrollableContainerRef,
            layoutControllerHook: ListPageLayoutController$Showside.useSubMenuSliderHeightSetter,
            onTitleClick: match$3.onSmartCardClick,
            key: category$1.id
          });
        } else {
          headerContent = null;
        }
        var mainContent = getContentOptimizedForLCP(Category$Showside.getChildren(category$1));
        return React.createElement(React.Fragment, undefined, headerContent, mainContent);
      case /* CLPWithFilters */6:
        var category$2 = listPageContentType._0;
        var match$6 = category$2.forcedPLPLayout;
        var match$7;
        if (typeof match$6 === "number" || match$6.TAG !== /* ProductGrid */3) {
          match$7 = [/* SevenColumnGrid */6, /* Half */1, undefined, undefined, undefined];
        } else {
          var match$8 = match$6._0;
          match$7 = [match$8.columns, match$8.gap, match$8.maxRows, match$8.maxWidth, match$8.padding];
        }
        var tmp = {
          index: 0,
          preferredContentType: /* Products */0,
          shouldShowHeader: !isForcingPLP && Category$Showside.hasSubCategories(category$2),
          shouldShowBackToTopButton: !isMobile,
          category: category$2,
          parentCategory: parentCategory,
          layout: {
            TAG: /* GridLayout */1,
            _0: {
              columns: isZoomEnabled ? gridColumns : match$7[0],
              gap: match$7[1],
              maxRows: match$7[2],
              maxWidth: match$7[3],
              padding: match$7[4],
              pattern: undefined
            }
          },
          scrollableContainerRef: scrollableContainerRef,
          enableInlineMedia: true,
          isThemeEnabled: false
        };
        var tmp$1 = isForcingPLP ? settings.productCardShape : undefined;
        if (tmp$1 !== undefined) {
          tmp.forcedShape = Caml_option.valFromOption(tmp$1);
        }
        var tmp$2 = isForcingPLP ? settings.productCardSize : undefined;
        if (tmp$2 !== undefined) {
          tmp.forcedSize = Caml_option.valFromOption(tmp$2);
        }
        return React.createElement(React.Fragment, undefined, React.createElement(SectionContent$Showside.make, tmp), renderHistorySlider(undefined));
      case /* PLPGrid */7:
        var match$9 = listPageContentType._1;
        var category$3 = listPageContentType._0;
        return React.createElement(React.Fragment, undefined, React.createElement(SectionContent$Showside.make, {
          index: 0,
          preferredContentType: getPreferredContentType(category$3),
          shouldShowHeader: !isForcingPLP && Category$Showside.hasSubCategories(category$3),
          shouldShowBackToTopButton: !isMobile,
          category: category$3,
          parentCategory: parentCategory,
          layout: {
            TAG: /* GridLayout */1,
            _0: {
              columns: isZoomEnabled ? gridColumns : match$9.columns,
              gap: match$9.gap,
              maxRows: match$9.maxRows,
              maxWidth: match$9.maxWidth,
              padding: match$9.padding,
              pattern: undefined
            }
          },
          scrollableContainerRef: scrollableContainerRef,
          enableInlineMedia: true,
          isThemeEnabled: false
        }), renderHistorySlider(undefined));
      case /* PLPSlider */8:
        var category$4 = listPageContentType._0;
        return React.createElement(SectionContent$Showside.make, {
          index: 0,
          preferredContentType: getPreferredContentType(category$4),
          shouldShowHeader: !isForcingPLP && Category$Showside.hasSubCategories(category$4),
          shouldShowBackToTopButton: !isMobile,
          category: category$4,
          parentCategory: parentCategory,
          layout: {
            TAG: /* SliderLayout */0,
            _0: listPageContentType._1
          },
          scrollableContainerRef: scrollableContainerRef,
          isThemeEnabled: false
        });
      case /* RelatedProducts */9:
        var columns = isMobile ? /* TwoColumnGrid */1 : Category$Showside.determineProductGridLayoutWithCardSize(undefined, undefined, settings.productCardSize);
        return React.createElement(React.Fragment, undefined, React.createElement(RelatedProductsContent$Showside.make, {
          productId: listPageContentType.productId,
          categoryId: "",
          hideOutOfStock: settings.hideOutOfStock,
          viewport: scrollableContainerRef,
          render: function (products) {
            var cards = Belt_Array.mapWithIndex(products, function (dataCount, product) {
              var tmp = {
                shape: settings.productCardShape,
                product: product,
                onClick: onRelatedProductClicked,
                onAddToCart: onAddToCart,
                onImageRendered: onMainImageRendered,
                onOpenLink: onOpenLink,
                dataCount: dataCount,
                key: product.id
              };
              if (isMiniPDPVisible !== undefined) {
                tmp.isMiniPDPVisible = Caml_option.valFromOption(isMiniPDPVisible);
              }
              return React.createElement(ProductCard$Showside.make, tmp);
            });
            return React.createElement(ListPageGrid$Showside.make, {
              columns: columns,
              children: cards
            });
          },
          displayVariantBySelector: displayVariantBy
        }), renderHistorySlider(undefined));
      case /* StoreCategoryProducts */10:
        var tmp$3 = {
          layout: {
            TAG: /* GridLayout */1,
            _0: {
              columns: isZoomEnabled ? gridColumns : isMobile ? /* TwoColumnGrid */1 : /* FourColumnGrid */3,
              gap: BasicTypes$Showside.emptyGridPayload.gap,
              maxRows: BasicTypes$Showside.emptyGridPayload.maxRows,
              maxWidth: BasicTypes$Showside.emptyGridPayload.maxWidth,
              padding: BasicTypes$Showside.emptyGridPayload.padding,
              pattern: BasicTypes$Showside.emptyGridPayload.pattern
            }
          },
          categoryId: listPageContentType.categoryId,
          isZoomEnabled: isZoomEnabled,
          scrollableContainerRef: scrollableContainerRef
        };
        if (listPageContentType.sourceNodeId !== undefined) {
          tmp$3.sourceNodeId = listPageContentType.sourceNodeId;
        }
        return React.createElement(React.Fragment, undefined, React.createElement(StoreCategoryProductsContent$Showside.make, tmp$3), renderHistorySlider(undefined));
    }
  }
}
ListPageContent$Show.displayName = "ListPageContent.Show";
var make = React.memo(ListPageContent$Show);
var Show = {
  make: make
};
function ListPageContent(Props) {
  var scrollableContainerRef = Props.scrollableContainerRef;
  var isSidebarOpen = Props.isSidebarOpen;
  var isMobileFiltersOpen = Props.isMobileFiltersOpen;
  var anchorHookResult = Props.anchorHookResult;
  var match = EntrypointContext$Showside.use(undefined);
  var onCategoryClick = match.onCategoryClick;
  var embedType = match.embedType;
  var match$1 = ViewportContext$Showside.use(undefined);
  var isMobile = match$1.isMobile;
  var match$2 = LCPContext$Showside.use(undefined);
  var isMainImageRendered = match$2.isMainImageRendered;
  var match$3 = ConfigurationProvider$Showside.use(undefined);
  var match$4 = match$3.config;
  var settings = match$4.settings;
  var topLevelCategories = match$4.categories;
  var match$5 = RouterProvider$Showside.useRouter(undefined);
  var listPageType = match$5.listPageType;
  var quickViewUnderlyingRoute = match$5.quickViewUnderlyingRoute;
  var _route = match$5.route;
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, topLevelCategories);
  var isForcingPLP = UseCategoryDisplayPriority$Showside.useCategoryDisplayPriority(activeCategory) === /* ProductsFirst */1;
  var isQuickViewOpen;
  isQuickViewOpen = typeof _route === "number" || _route.TAG !== /* QuickView */3 ? false : true;
  var route = quickViewUnderlyingRoute !== undefined ? quickViewUnderlyingRoute : _route;
  var indexCategory = settings.indexNode;
  var match$6 = settings.indexNode;
  var parentCategory = activeCategory !== undefined ? activeCategory : match$6 !== undefined ? match$6 : LegacyShowside_CategoryDecoders$ApiTypes.empty;
  var relatedProductsId = Belt_Option.flatMap(listPageType, function (id) {
    if (typeof id === "number" || id.TAG !== /* Product */1) {
      return;
    } else {
      return id._0;
    }
  });
  var listPageContentType = ListPageTypes$Showside.getListPageContentType(parentCategory, activeCategory, indexCategory, relatedProductsId, route, isForcingPLP, undefined);
  React.useEffect(function () {
    if (isMainImageRendered) {
      Curry._1(Sidebar_Lazy$Showside.preload, undefined);
      Curry._1(FiltersPanel_Lazy$Showside.preload, undefined);
      Curry._1(ProductDetailsPage_Lazy$Showside.preload, undefined);
    }
  }, [isMainImageRendered]);
  var match$7 = UseSidebar$Showside.isEnabled(activeCategory, settings, listPageType, isForcingPLP);
  var shouldShowSidebar = match$7[0] || match$7[1] ? true : false;
  var connection = Belt_Option.flatMap(activeCategory, Category$Showside.ExternalConnection.getStoreCategoryConnection);
  var content = React.createElement(ConditionalRender$Showside.When.make, {
    condition: !isMobile || !isQuickViewOpen,
    children: React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["smartnav-main flex flex-col w-full", Belt_Option.mapWithDefault(activeCategory, "space-y-row-custom pt-row-custom-half", function (category) {
        if (Belt_Option.isSome(category.socialNetworkSource)) {
          return "";
        } else {
          return "space-y-row-custom pt-row-custom-half";
        }
      })]))
    }, React.createElement(make, {
      listPageContentType: listPageContentType,
      activeCategory: activeCategory,
      parentCategory: parentCategory,
      topLevelCategories: topLevelCategories,
      isForcingPLP: isForcingPLP,
      isSidebarOpen: isSidebarOpen,
      isMobile: isMobile,
      scrollableContainerRef: scrollableContainerRef,
      anchorHookResult: anchorHookResult,
      onBackClick: match.onBackClick,
      onAddToCart: match.onAddToCart,
      onCategoryClick: onCategoryClick,
      onOpenLink: match.onOpenLink
    }))
  });
  var tmp;
  if (typeof route === "number") {
    tmp = false;
  } else {
    switch (route.TAG | 0) {
      case /* Home */0:
      case /* ListPage */1:
        tmp = true;
        break;
      default:
        tmp = false;
    }
  }
  var tmp$1 = {
    listPageContentType: listPageContentType,
    scrollableContainerRef: scrollableContainerRef
  };
  if (activeCategory !== undefined) {
    tmp$1.category = Caml_option.valFromOption(activeCategory);
  }
  var tmp$2 = {
    listPageContentType: listPageContentType,
    isSidebarOpen: isSidebarOpen,
    topLevelCategories: topLevelCategories
  };
  if (anchorHookResult !== undefined) {
    tmp$2.anchorHookResult = Caml_option.valFromOption(anchorHookResult);
  }
  if (activeCategory !== undefined) {
    tmp$2.category = Caml_option.valFromOption(activeCategory);
  }
  var tmp$3;
  var exit = 0;
  if (typeof listPageContentType === "number") {
    exit = 1;
  } else {
    switch (listPageContentType.TAG | 0) {
      case /* IndexSlider */0:
      case /* IndexGrid */1:
        if (embedType !== 1) {
          exit = 1;
        } else {
          tmp$3 = null;
        }
        break;
      default:
        exit = 1;
    }
  }
  if (exit === 1) {
    tmp$3 = React.createElement("div", {
      className: CSS$Showside.prefix("smartnav-endspace h-26 mt-6 w-full")
    });
  }
  return React.createElement(ConditionalRender$Showside.When.make, {
    condition: tmp,
    children: null
  }, React.createElement(ListPagePills$Showside.make, {
    topLevelCategories: topLevelCategories,
    activeCategory: activeCategory
  }), React.createElement(ListPageHeading$Showside.make, tmp$1), React.createElement(ListPageToolbar$Showside.make, tmp$2), React.createElement(ListPageMobileNavbar$Showside.make, {
    scrollableContainerRef: scrollableContainerRef
  }), React.createElement(ListPageMobileFilters$Showside.make, {
    activeCategory: activeCategory,
    connection: connection,
    isOpen: isMobileFiltersOpen
  }), content, React.createElement(ListPageSidebarWrapper$Showside.make, {
    category: activeCategory,
    appliedFilters: match$5.productFilters,
    appliedSort: match$5.productSort,
    shouldShowSidebar: shouldShowSidebar,
    isSidebarOpen: isSidebarOpen,
    topLevelCategories: topLevelCategories,
    onCategoryClick: onCategoryClick
  }), tmp$3);
}
ListPageContent.displayName = "ListPageContent";
var make$1 = React.memo(ListPageContent);
var $$default = make$1;
export { getPreferredContentType, OptimizedForLCP, LazySection, Show, make$1 as make, $$default, $$default as default };
/* make Not a pure module */